import { useState, useEffect } from "react";
import Chart from "react-apexcharts";
import {
  Box,
  createTheme,
  Stack,
  Typography,
  Grid,
  IconButton,
} from "@mui/material";
import QuestionMarkIcon from "@mui/icons-material/QuestionMark";
import { styled } from "@mui/material/styles";
import Button from "@mui/material/Button";
import Tooltip, { TooltipProps, tooltipClasses } from "@mui/material/Tooltip";
import ViewListIcon from "@mui/icons-material/ViewList";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import CompareArrowsIcon from "@mui/icons-material/CompareArrows";
import { tableCellClasses } from "@mui/material/TableCell";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  mode: "dark",
  [`&.${tableCellClasses.head}`]: {
    // backgroundColor: theme.palette.common.black,
    // color: theme.palette.common.white,
    fontSize: 12,
    fontFamily: "public sans",
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 11,
    fontFamily: "public sans",
  },
}));

const NetIncomeChart = ({
  incomeDetails,
  mode,
  financialPeriod,
  isComparing,
  setOpenComparison,
}) => {
  // console.log("income details", incomeDetails);
  const [dataView, setDataView] = useState(false);
  const [netIncomeData, setNetIncomeData] = useState();
  const [timePeriods, setTP] = useState();
  const [netIncome, setNI] = useState();
  const [AllCompNetInc, setAllCompNetInc] = useState([]);

  useEffect(() => {
    if (!isComparing) {
      // console.log("income details", financialPeriod, incomeDetails);
      if (financialPeriod == "quarterly") {
        if (incomeDetails?.quarterly?.income?.length > 0) {
          let data = incomeDetails?.quarterly?.income?.map((i) => {
            return {
              fiscalPeriod: `FY${i?.fiscalYear - 2000} Q${i?.fiscalQuarter}`,
              netIncome: i?.netIncome,
            };
          });
          let temp = [];
          // console.log("d=>", data);

          for (let i = 15; i >= 0; i--) {
            temp?.push(data[i]);
          }
          setTP(temp.map((t) => t?.fiscalPeriod));
          setNI(temp.map((t) => t?.netIncome));
          // console.log("data>", temp);
          setNetIncomeData(temp);
        }
      } else {
        // console.log("rrrrrrrrrrrrrrr");
        if (incomeDetails?.annual?.income?.length > 0) {
          let data = incomeDetails?.annual?.income?.map((i) => {
            return {
              fiscalPeriod: `${i?.fiscalYear}`,
              netIncome: i?.netIncome,
            };
          });
          let temp = [];
          // console.log("d=>", data);

          for (let i = incomeDetails?.annual?.income?.length - 1; i >= 0; i--) {
            temp?.push(data[i]);
          }
          setTP(temp.map((t) => t?.fiscalPeriod));
          setNI(temp.map((t) => t?.netIncome));
          // // console.log("data>", temp);
          setNetIncomeData(temp);
        }
      }
    }
  }, [incomeDetails, financialPeriod]);
  /********** while comparing */
  useEffect(() => {
    if (isComparing && incomeDetails?.length > 0) {
      console.log("income details", financialPeriod, incomeDetails);
      if (financialPeriod == "quarterly") {
        setTP(incomeDetails.map((t) => t?.financialPeriod));
        let symbols = incomeDetails[0]?.incomes?.map(
          (income) => income?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return incomeDetails?.map((i) => {
            return i?.incomes[ind]?.netIncome;
          });
        });
        // console.log("series", series);
        setAllCompNetInc(series);
      } else {
        setTP(incomeDetails.map((t) => t?.financialPeriod));

        let symbols = incomeDetails[0]?.incomes?.map(
          (income) => income?.symbol
        );
        // console.log("symbols", symbols);
        let series = symbols?.map((sym, ind) => {
          // console.log("sym", sym);
          return incomeDetails?.map((i) => {
            return i?.incomes[ind]?.netIncome;
          });
        });
        // console.log("series", series);
        setAllCompNetInc(series);
      }
    }
  }, [incomeDetails, financialPeriod]);
  // console.log("time periods", timePeriods);
  // console.log(
  //   "series",
  //   AllCompNetInc?.length > 0
  //     ? incomeDetails[0]?.incomes?.map((inc, i) => {
  //         return { name: inc?.symbol, data: AllCompNetInc[i] };
  //       })
  //     : []
  // );

  /********** */
  var options = {
    series: !isComparing
      ? [
          {
            name: "Net Income",
            data: netIncome,
          },
          // {
          //   name: "Net Income",
          //   data: netIncome,
          // },
        ]
      : AllCompNetInc?.length > 0
      ? incomeDetails[0]?.incomes?.map((inc, i) => {
          return { name: inc?.symbol, data: AllCompNetInc[i] };
        })
      : [],
    chart: {
      type: "bar",
      height: 1400,
      background: "transparent",
      toolbar: {
        show: true,

        tools: {
          download: true,
        },
        export: {
          csv: {
            filename: financialPeriod + " - Net Income",
            columnDelimiter: ",",
            headerCategory: "Financial Period",
            headerValue: "value",
            dateFormatter(timestamp) {
              return new Date(timestamp).toDateString();
            },
          },
          svg: {
            filename: financialPeriod + " - Net Income",
          },
          png: {
            filename: financialPeriod + " - Net Income",
          },
        },
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: window?.screen?.width > 768 ? "55%" : "70%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    colors: ["#29d293", "#ec544c", "#fcc432", "#985ceb", "#2d79db"],
    legend: {
      show: true,
      showForSingleSeries: false,
      showForNullSeries: true,
      showForZeroSeries: true,
      position: "top",
      horizontalAlign: "center",
      floating: false,
      fontSize: window?.screen?.width > 768 ? "14px" : "10px",
      fontFamily: "public sans",
      fontWeight: 400,
      labels: {
        useSeriesColors: true,
      },
      itemMargin: {
        horizontal: 5,
        vertical: 5,
      },
      onItemClick: {
        toggleDataSeries: true,
      },
      onItemHover: {
        highlightDataSeries: true,
      },
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    grid: {
      show: true,
      borderColor: mode == "light" ? "#d9d9d999" : "#d9d9d955",
      row: {},
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: true,
        },
      },
    },
    theme: {
      mode: mode,
      // palette: "palette2",
    },
    xaxis: {
      lines: {
        show: false, //or just here to disable only y axis
      },
      axisBorder: {
        show: true,
      },
      axisTicks: {
        show: false,
      },
      categories: timePeriods,
      labels: {
        show: true,
        rotate: -50,
        rotateAlways: window?.screen?.width > 768 ? false : true,
        hideOverlappingLabels: true,
        showDuplicates: false,
        trim: false,
        maxHeight: 120,
        style: {
          color: new Array(timePeriods?.length)?.fill("#ff0000"),
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-xaxis-label",
        },
        offsetX: 0,
        offsetY: 0,
      },
    },
    yaxis: {
      tickAmount: 10,
      title: {
        text: "",
      },
      labels: {
        formatter: function (value) {
          return numFormatter(value);
        },
        style: {
          colors: [],
          fontSize: "10px",
          fontFamily: "public sans",
          fontWeight: 400,
          cssClass: "apexcharts-yaxis-label",
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return "$" + numFormatter(val);
        },
      },
    },
  };
  const LightTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.white,
      color: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontFamily: "public sans",
      fontWeight: 300,
    },
  }));

  const BootstrapTooltip = styled(({ className, ...props }) => (
    <Tooltip {...props} arrow classes={{ popper: className }} />
  ))(({ theme }) => ({
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.common.black,
    },
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.common.black,
      backgroundColor: "rgba(0, 0, 0, 0.87)",
      boxShadow: theme.shadows[1],
      fontSize: 12,
      fontWeight: 300,
      fontFamily: "public sans",
    },
  }));
  const [chartDescription, x] = useState(
    "Net income, also called, net earnings is calculated as revenue minus cost of goods sold, operating expenses, depreciation, interest, taxes and other expenses."
  );
  /************************************************************************************************ */
  return (
    <div>
      <Box
        sx={{
          fontFamily: "public sans",
          fontSize: "2rem",
          color: "fontPrimaryColor.main",
        }}
        className="chart__title"
      >
        Net Income
      </Box>
      {dataView ? (
        <>
          <Box
            sx={{
              // width: "20vw",
              minWidth: "300px",
              marginLeft: "50%",
              transform: "translateX(-50%)",
            }}
            onClick={() => console.log("option.series", options?.series)}
          >
            <TableContainer component={Paper}>
              <Table
                sx={{
                  minWidth: 50,
                  fontFamily: "public sans",
                }}
                size="small"
                aria-label="a dense table"
              >
                <TableHead
                  sx={{
                    backgroundColor: "bgSecondary.main",
                    color: "fontSecondaryColor.main",
                  }}
                >
                  <TableRow
                    sx={{
                      backgroundColor: "bgSecondary.main",
                    }}
                  >
                    <StyledTableCell
                      sx={{
                        color: "fontPrimaryColor.main",
                      }}
                    >
                      Financial Periods
                    </StyledTableCell>
                    {options?.series?.length > 0 &&
                      options?.series?.map((ser) => (
                        <StyledTableCell
                          sx={{
                            color: "fontPrimaryColor.main",
                            textAlign: "right",
                          }}
                        >
                          {ser?.name}
                        </StyledTableCell>
                      ))}

                    {/* <StyledTableCell
                      sx={{
                        color: "fontPrimaryColor.main",
                      }}
                      align="right"
                    >
                      Net Income
                    </StyledTableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {new Array(timePeriods?.length).fill("1").map((row, i) => (
                    <TableRow
                      key={timePeriods[i]}
                      sx={{
                        backgroundColor: "bgPrimary.main",
                        boxShadow:
                          mode == "dark"
                            ? "#888 0px 0px 0px 1px"
                            : "#e6e6e6 0px 0px 0px 1px",
                      }}
                    >
                      <StyledTableCell
                        sx={{
                          color: "fontSecondaryColor.main",
                          borderBottom: "none",
                        }}
                        component="th"
                        scope="row"
                      >
                        {timePeriods[i]}
                      </StyledTableCell>
                      {options?.series?.length > 0 &&
                        options?.series?.map((ser) => (
                          <StyledTableCell
                            sx={{
                              color: "fontSecondaryColor.main",
                              borderBottom: "none",
                            }}
                            align="right"
                          >
                            {numFormatter(ser?.data && ser?.data[i])}
                          </StyledTableCell>
                        ))}
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
        </>
      ) : isComparing ? (
        <>
          {incomeDetails?.length > 0 && (
            <Chart
              options={options}
              series={options?.series}
              type="bar"
              height={window?.screen?.width > 600 ? "200%" : "150%"}
              width="100%"
            />
          )}
        </>
      ) : (
        <Chart
          options={options}
          series={options?.series}
          type="bar"
          height={window?.screen?.width > 600 ? "200%" : "150%"}
          width="100%"
        />
      )}

      <Box className="chart__bottom__options__bar" sx={{ gap: "10px" }}>
        <Box
          className="showChartInfoBtn"
          sx={{ backgroundColor: "bgSecondary.main", borderRadius: "50%" }}
        >
          {mode == "dark" ? (
            <LightTooltip title={chartDescription} arrow>
              <Box>
                <QuestionMarkIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </Box>
            </LightTooltip>
          ) : (
            <BootstrapTooltip title={chartDescription} arrow>
              <QuestionMarkIcon
                sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
              />
            </BootstrapTooltip>
          )}
        </Box>
        <Box onClick={() => setDataView(!dataView)}>
          <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
            <ViewListIcon
              sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
            />
          </IconButton>
        </Box>
        {!isComparing && (
          <>
            <Box onClick={() => setOpenComparison(true)}>
              <IconButton sx={{ backgroundColor: "bgSecondary.main" }}>
                <CompareArrowsIcon
                  sx={{ color: "fontSecondaryColor.main", fontSize: "20px" }}
                />
              </IconButton>
            </Box>
          </>
        )}
      </Box>
    </div>
  );
};

export default NetIncomeChart;

function numFormatter(num) {
  if (num > 999 && num < 1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num > 1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num > 100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num > 1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num < 900 && num > 0) {
    return num; // if value < 1000, nothing to do
  } else if (num < -999 && num > -1000000) {
    return (num / 1000).toFixed(0) + "K"; // convert to K for number from > 1000 < 1 million
  } else if (num < -1000000000000) {
    return (num / 1000000000000).toFixed(2) + "T"; // convert to M for number from > 1 million
  } else if (num < -100000000) {
    return (num / 1000000000).toFixed(2) + "B"; // convert to M for number from > 1 million
  } else if (num < -1000000) {
    return (num / 1000000).toFixed(2) + "M"; // convert to M for number from > 1 million
  } else if (num > -900) {
    return num; // if value < 1000, nothing to do
  }
}
